import SidebarItem from '@Web/Pages/Web/OurSoftware/Components/SidebarItem/index.jsx';
import SectionHeader from '@Web/Src/Components/SectionHeader/index.jsx';
import { useEffect, useState } from 'react';
import { usePage } from '@inertiajs/react';
import ImageLazy from '@Web/Src/Components/Image/Lazy/index.jsx';

function SoftwareAbilities({
    data,
    title = '',
    desc = '',
    registerButton = false,
    className = '',
    topTitle = false,
    icon = 'atom',
    type = 'dark',
}) {
    const section = usePage().props.query.section;
    const [currentPage, setCurrentPage] = useState(
        data.find((item) => item.value === section) ?? data[0]
    );

    const [openItem, setOpenItem] = useState(null);

    useEffect(() => {
        if (section) {
            setOpenItem(section);
        } else {
            setOpenItem('builder');
        }
    }, []);

    const handleToggle = (item) => {
        setOpenItem((prev) => (prev === item.value ? null : item.value));
        setCurrentPage(item);
    };

    return (
        <div className={`${className} text-dark mx-auto w-full max-w-[1250px]`}>
            <SectionHeader
                topTitle={topTitle}
                className='mx-auto mt-40'
                icon={icon}
                title={title}
                desc={desc}
                type={type}
            />
            <div className='bg-light medium:block mt-16 flex w-full items-center gap-4 rounded-3xl shadow-[0px_0px_32px_0px_rgba(9,21,57,0.15)]'>
                <div className='medium:p-6 small:!p-4 flex flex-1 flex-col items-center p-10'>
                    {data.map((item) => {
                        return (
                            <SidebarItem
                                registerButton={registerButton}
                                key={item.value}
                                currentPage={currentPage}
                                setCurrentPage={setCurrentPage}
                                item={item}
                                isOpen={openItem === item.value}
                                onToggle={() => handleToggle(item)}
                            />
                        );
                    })}
                </div>
                <div className='medium:mt-5 medium:hidden flex w-full flex-1 justify-center p-5'>
                    {data.map((item) => {
                        return (
                            <ImageLazy
                                key={item.value}
                                className={`h-auto w-full max-w-[450px] ${currentPage.value === item.value ? 'inline' : '!hidden'}`}
                                src={`/assets/images/webp/web/demo-section/${item.img}.webp`}
                                lowSrc={`/assets/images/webp/web/demo-section/${item.img}-low.webp`}
                                alt={item.value || 'Software Ability'}
                            />
                        );
                    })}
                </div>
            </div>
        </div>
    );
}

export default SoftwareAbilities;
